import type { CascadeTuning } from "@slot/mechanics-cascade";

// The board's motion VALUES (the cascade mechanic's shapes) — the only file to edit to retune them: the board clearing
// at a spin's start, the new board dropping in, the survivors falling after a merge. They are the Cocos cascade
// template's (khorenj/slot-frontend-template `gridMotionTuning.ts`, its pre-spin drop-out at 0.5 s); the new board
// starts falling `revealDelaySeconds` after the old board's last column's top starts to fall (decision 48), and each new
// symbol starts 6.5 rows above its cell — the whole board above the grid, past the panel's clip above the top row. The
// tumble after a merge (the `cascade` block) is faster than the template's (user, 2026-10-05: "make the tumble faster"):
// a symbol's start waits its column's offset plus its place in the column, counted from the bottom and the symbols
// that stay put included, so the staggers are the dead time — at the template's 0.08 a column cleared at its top two
// rows waited 0.32 s before anything moved. Every column falls at once (no column stagger, user 2026-10-05), each
// column's cells 0.02 s apart: the worst case is ~0.32 s (the template's ~1.15). The removal block is the
// cascade's own removal (a canonical `remove_symbols_by_mask`), all its cells at once; a merge's consumed cells leave
// through the merge instead.

export const CASCADE_TUNING: CascadeTuning = {
  motion: {
    bonusMode: { speedMultiplier: 1.25 },
    dropout: { durationSeconds: 0.5, columnStaggerSeconds: 0.08, withinColumnStaggerSeconds: 0.018, dropDistanceRows: 7, easing: "quartIn", revealDelaySeconds: 0.2 },
    reveal: {
      dropDurationSeconds: 0.28,
      columnStaggerSeconds: 0.12,
      withinColumnStaggerSeconds: 0.03,
      spawnStartOffsetRows: 6.5,
      overshoot: { enable: true, pixels: 10, phaseRatio: 0.78, settleEasing: "quadOut" },
    },
    cascade: {
      fallDurationSeconds: 0.22,
      spawnDurationSeconds: 0.2,
      columnStaggerSeconds: 0,
      withinColumnStaggerSeconds: 0.02,
      overshoot: { enable: true, pixels: 10, phaseRatio: 0.78, settleEasing: "quadOut" },
    },
  },
  // A removal's cells shrink together, no column or row waiting on another (user, 2026-10-10).
  win: { removal: { shrinkSeconds: 0.18, postRemovalHoldSeconds: 0.1, columnStaggerSeconds: 0, withinColumnStaggerSeconds: 0 } },
};
